import OrderRequestorSelect from "./orderRequestorSelect.container";

export default OrderRequestorSelect;
